import Image from "next/image";

export default function Home() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Image
        src="/jobber-icon.svg"
        alt="Jobber Logo"
        width={200}
        height={200}
      />
    </div>
  );
}
